@charset "UTF-8";

/* src/app/forms/instance-generic-view/instance-generic-view.component.scss */
.block {
  animation: 1s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  animation: fadeIn 10s;
  animation-delay: 40s;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.mktplace {
  overflow: auto;
  height: 100%;
  padding-top: 10px;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.tabcontent {
  height: 100%;
  overflow-y: auto;
}
.view-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .view-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
nz-tabs {
  height: 100%;
}
:host ::ng-deep .custom-tabs .ant-tabs-content,
:host ::ng-deep .custom-tabs .ant-tabs-tabpane {
  height: 100%;
}
.cardcontent {
  height: 25%;
}
.hl {
  border-top: 1px solid var(--tem-border);
  width: 100%;
  margin-top: 20px;
  height: 1%;
}
.transformimage {
  transform: scale(1.5);
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 20px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.smallSvg {
  padding-top: 4px;
  transform: scale(1.5);
}
.mediumSvg {
  padding-top: 4px;
  transform: scale(2);
}
.bigSvg {
  padding-top: 4px;
  transform: scale(3);
}
.titleClass {
  display: flex;
  position: relative;
  align-items: center;
}
.tab-header {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.tab-order {
  background: color-mix(in srgb, var(--tem-ink) 12%, transparent);
  border-radius: var(--tem-radius);
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
  min-height: 60px;
}
.list-order {
  width: 300px;
  max-width: 100%;
  border: solid 1px var(--tem-border);
  min-height: 60px;
  display: block;
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
  box-shadow: var(--tem-shadow);
  overflow: auto;
  max-height: 300px;
  height: 100%;
}
.list-order-box {
  padding: 15px 10px;
  border-bottom: solid 1px var(--tem-border);
  color: var(--tem-ink);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  font-size: 12px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 10px;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.list-order-box:last-child {
  border: none;
}
/*# sourceMappingURL=instance-generic-view.component.css.map */
